import React from "react";
import "./Header.css";

function Header({ onMenuToggle, isMenuOpen }) {
  return (
    <header className="header">
      <button className="menu-button" onClick={onMenuToggle}>
        {isMenuOpen ? "CLOSE" : "MENU"}
      </button>
    </header>
  );
}

export default Header;

